import React, { useCallback, useEffect, useRef } from 'react';
import { Cropper, CropperRef } from 'react-advanced-cropper';
import './style/imageCropper.css';

interface ImageCropperProps {
  imageUrl: string;
  maxWidth?: number;
  maxHeight?: number;
  aspectRatio?: number;
  onCropBlob?: (blob: Blob | null) => void;
  mimeType?: string;
  quality?: number;
}

export const ImageCropper: React.FC<ImageCropperProps> = ({
  imageUrl,
  maxWidth,
  maxHeight,
  onCropBlob,
  aspectRatio,
  mimeType,
  quality,
}) => {
  const cropperRef = useRef<CropperRef>(null);

  const handleCrop = useCallback(() => {
    const canvasIntance = cropperRef.current?.getCanvas({
      maxWidth: 400,
      maxHeight: 300,
    });

    const canvasContext = canvasIntance?.getContext('2d');
    if (canvasContext) {
      canvasContext.imageSmoothingQuality = 'low';
    }

    canvasIntance?.toBlob(
      (blob) => {
        onCropBlob?.(blob);
      },
      mimeType,
      quality,
    );
  }, [mimeType, onCropBlob, quality]);

  useEffect(() => {
    const retInterval = setInterval(() => {
      if (cropperRef.current?.getCanvas()) {
        clearInterval(retInterval);
        handleCrop();
      }
    }, 500);
  }, [handleCrop]);

  return (
    <div
      className='wrapper-cropper'
      style={{ width: maxWidth, height: maxHeight }}
      data-testid='image-cropper'>
      <Cropper
        ref={cropperRef}
        src={imageUrl}
        className={'cropper'}
        onChange={handleCrop}
        stencilProps={{
          aspectRatio,
        }}
        defaultSize={
          aspectRatio
            ? undefined
            : ({ imageSize, visibleArea }) => ({
                width: (visibleArea || imageSize).width,
                height: (visibleArea || imageSize).height,
              })
        }
      />
    </div>
  );
};
